
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'WorldIcon',

  props: {
    mimeTypeSlag: String
  }
})
